export const inInTransition = (pathName: string) => {
  return pathName.indexOf('/structures') === 0
}
